import { toast } from "react-toastify";

let isRedirecting = false;

export function handleAuthFailure() {
  // Already on login page — do nothing
  if (window.location.pathname === "/login") return;

  if (isRedirecting) return;
  isRedirecting = true;

  toast.dismiss();
  toast.error("Session expired. Please login again.", {
    position: "top-right",
    autoClose: 2000,
  });

  // Clear ALL auth keys so isAuthenticated() returns false immediately,
  // stopping any components from re-firing API calls before redirect
  localStorage.removeItem("authUser");
  localStorage.removeItem("auth_token");
  localStorage.removeItem("user_info");

  setTimeout(() => {
    isRedirecting = false;
    window.location.href = "/login";
  }, 2000);
}

export function isAuthRedirecting() {
  return isRedirecting;
}
